import type { RotasDoModulo } from '@/app/rotas';

import { InsuredDetailPage } from './InsuredDetailPage';
import { InsuredsPage } from './InsuredsPage';

/** A lista de segurados e o detalhe do segurado (P-SEG-1). */
export const rotas: RotasDoModulo = {
  menu: { '/segurados': InsuredsPage },
  moldura: [
    {
      path: '/segurados/:insuredId',
      element: <InsuredDetailPage />,
    },
  ],
};
